import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";


import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable()
export class CommunictionService {

  constructor(private http: HttpClient) { }
  node: Array<any> = []

  cancelTask(agentId, task_id, parent_id = null) {
    let url = environment.communication_service_api + "notifications/" +  agentId + "/notifications/revoke_task/" + task_id
    if (parent_id) {
      url += ("/" + parent_id)
    }
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        console.error('An error occurred:', error);
        return throwError(error);
      })
    );
  }

  checkStatus(taskId) {
    return this.http.get(environment.communication_service_api + "notifications/notifications/task_status/" + taskId)
  }

  
}
